//Styles and Sage Carbon 
import './App.css';
import GlobalStyle from 'carbon-react/lib/style/global-style';
import CarbonProvider from "carbon-react/lib/components/carbon-provider";
// import sageTheme from "carbon-react/lib/style/themes/sage";
import sageTheme from "carbon-react/lib/style/themes/mint";
import "carbon-react/lib/style/fonts.css"; //needed otherwise e.g. icons don't display on components

//Components and pages 
import Navbar from './Components/Navbar';
import Login from "./Pages/Login/Login";
import ErrorPage from './Pages/Error/ErrorPage';
import RequestPage from './Pages/RequestPage/RequestPage';

//React Modules
import { BrowserRouter as Router, Routes, Route, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import {createBrowserHistory} from 'history';
import ExecutePage from './Pages/ExecutePage/ExecutePage';


export const history = createBrowserHistory();

const App = ()  =>{


  return (

    <CarbonProvider theme={sageTheme}>
      <GlobalStyle />
     <HistoryRouter history={history}>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path = "/" element = {<Login/>} />     
            <Route path = "*" element = {<ErrorPage/>}/>     
            <Route path = "/requestpage" element = {<RequestPage/>}/>
            <Route path = "/executepage" element = {<ExecutePage/>}/>
          </Routes>
        </div>
      </HistoryRouter>
    </CarbonProvider>
    
  );
}

export default App;
